import { useDispatch, useSelector } from 'react-redux';
import { MAPPING_FILTERS_CONFIG_KEY } from 'constants/ac-led-mapping';
import { store } from 'redux-rest-reducer';
import { useEffect } from 'react';
import { get as getConfig } from 'actions/configs';

const useLogic = ({
  filters,
  configKey = MAPPING_FILTERS_CONFIG_KEY,
  mapperType,
  dateTimePreset,
}) => {
  const configs = useSelector(({ configs }) => configs);
  const dispatch = useDispatch();

  const { filters: mappingFilters } = store.get(configs, configKey)?.data ?? {};

  useEffect(() => {
    dispatch(getConfig?.(configKey));
  }, []);
  const isDisabled = mappingFilters?.some(el => el?.is_required && !filters?.[el?.code]);

  return {
    mappingFilters: mappingFilters,
    isDisabled,
  };
};

export default useLogic;
